<template>
  <div id="homepage-blocks">
    <template v-if="showInboxBlock">
      <v-teleport to="div#mount-user-inbox-block" :disabled="false">
        <UserInboxBlock></UserInboxBlock>
      </v-teleport>
    </template>
    <template v-if="showELabNextBlock">
      <v-teleport to="div#mount-elabnext-button" :disabled="false">
        <eLabNextButton></eLabNextButton>
      </v-teleport>
    </template>
    <v-teleport to="div#mount-report-choice" :disabled="false">
      <ReportChoice></ReportChoice>
    </v-teleport>
  </div>
</template>

<script>
import { useEnvVars } from "@/composables/useEnvVars";
import { useModulesEnabled } from "@/composables/useModulesEnabled";
import ELabNextButton from "@/components/platform/scisure_integration/eLabNextButton.vue";
import UserInboxBlock from "../raft_messaging/UserInboxBlock.vue";
import ReportChoice from "../platform/ReportChoice.vue";
import VTeleport from "./VTeleport.vue";
import { restClient } from "@/lib/raftApi";
import { useNotification } from "@/composables/useNotification";

export default {
  name: "VHomepageBlocks",
  components: {
    UserInboxBlock,
    ReportChoice,
    VTeleport,
    ELabNextButton,
  },
  data() {
    return {
      config: null,
    };
  },
  setup() {
    const { isB4 } = useEnvVars();
    const { modulesEnabled } = useModulesEnabled();
    const { showNotification } = useNotification();
    return {
      isB4,
      modulesEnabled,
      showNotification,
    };
  },
  computed: {
    showInboxBlock() {
      return this.isB4 && this.modulesEnabled?.raft_messaging;
    },
    showELabNextBlock() {
      // Check if the element exists in the DOM.  If it does not, and you try to
      // mount the component, v-teleport locks up the browser.
      return (
        document.querySelector("div#mount-elabnext-button") &&
        this.modulesEnabled?.scisure_integration &&
        this.config?.enable_elabnext_block
      );
    },
  },
  methods: {
    async getConfig() {
      try {
        this.config = await restClient.get({
          path: "configuration/scisure_integration.elabnext",
          queries: {},
        });
      } catch (exception) {
        this.showNotification({
          message:
            "An error has occurred. Please try again later. " + exception,
          type: "error",
        });
      }
    },
  },
  async created() {
    await this.getConfig();
  },
};
</script>
